@layer tbw-plugins {
  /**
   * Context Menu Styles
   *
   * The context menu is appended to document.body (outside tbw-grid).
   * CSS custom properties are copied from the grid element at render time,
   * allowing themes to set variables on tbw-grid that apply to the menu.
   *
   * Fallback chain:
   * 1. --tbw-context-menu-* (plugin-specific override)
   * 2. --tbw-color-* (base theme variable, copied from grid)
   */
  .tbw-context-menu {
    position: fixed;
    background: var(--tbw-context-menu-bg, var(--tbw-color-panel-bg));
    color: var(--tbw-context-menu-fg, var(--tbw-color-fg));
    border: 1px solid var(--tbw-context-menu-border, var(--tbw-color-border));
    border-radius: var(--tbw-context-menu-radius, var(--tbw-border-radius));
    box-shadow: var(--tbw-context-menu-shadow, 0 2px 10px var(--tbw-color-shadow));
    min-width: var(--tbw-context-menu-min-width, var(--tbw-menu-min-width));
    padding: var(--tbw-spacing-xs) 0;
    z-index: 10000;
    font-size: var(--tbw-context-menu-font-size, var(--tbw-font-size-sm));
    font-family: var(--tbw-context-menu-font-family, var(--tbw-font-family));
  }

  .tbw-context-menu-item {
    display: flex;
    align-items: center;
    padding: var(--tbw-context-menu-item-padding, var(--tbw-menu-item-padding));
    cursor: pointer;
    gap: var(--tbw-context-menu-item-gap, var(--tbw-menu-item-gap));
  }

  .tbw-context-menu-item:hover:not(.disabled) {
    background: var(--tbw-context-menu-hover, var(--tbw-color-row-hover));
  }

  .tbw-context-menu-item.disabled {
    opacity: 0.5;
    cursor: default;
  }

  .tbw-context-menu-item.danger {
    color: var(--tbw-context-menu-danger, var(--tbw-color-danger));
  }

  .tbw-context-menu-icon {
    width: var(--tbw-context-menu-icon-size, var(--tbw-icon-size));
    text-align: center;
  }

  .tbw-context-menu-label {
    flex: 1;
  }

  .tbw-context-menu-shortcut kbd {
    color: var(--tbw-context-menu-muted, var(--tbw-color-fg-muted));
    font-size: var(--tbw-context-menu-shortcut-size, var(--tbw-font-size-xs));
  }

  .tbw-context-menu-arrow {
    font-size: var(--tbw-context-menu-arrow-size, var(--tbw-font-size-2xs));
    color: var(--tbw-context-menu-muted, var(--tbw-color-fg-muted));
  }

  .tbw-context-menu-separator {
    height: 1px;
    background: var(--tbw-context-menu-border, var(--tbw-color-border));
    margin: var(--tbw-spacing-xs) 0;
  }
} /* End @layer tbw-plugins */
